import { Button } from '@ekhodealer/ekho-common/rev';

import type { LeadsTableRow } from '@ekhodealer/ekho-common';

import { TextCell } from '@common/components/TextCell';

import { useLeadNavigation } from '../../hooks/useLeadNavigation';

interface TasksCellProps {
	item: LeadsTableRow;
}

export const TasksCell = ({ item }: TasksCellProps) => {
	const { openLeadDetails } = useLeadNavigation();
	const taskCount = item.numberOfTasks || 0;

	if (taskCount === 0) {
		return <TextCell value='--' />;
	}

	const taskText = taskCount === 1 ? '1 task' : `${taskCount} tasks`;

	return (
		<Button
			variant='filled'
			size='medium'
			onPress={() => openLeadDetails(item.id)}
			ariaLabel={taskText}>
			<div style={{ width: '100px' }}>{taskText}</div>
		</Button>
	);
};
